require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-weichselbaum.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-weichselbaum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-weichselbaum!./.cache/json/betreuungseinrichtungen-jennersdorf-weichselbaum.json
// module id = 921
// module chunks = 231608221292675